import Vue from "vue";
import Vuex from "vuex";
import firebase, { createFirestoreModules } from "@/plugins/firebase";

import application from "./modules/application";
import editor from "./modules/editor";
import user from "./modules/user";
import events from "./modules/events";
import slides from "./modules/slides";

Vue.use(Vuex);

let fireStorePlugins = createFirestoreModules([
  user,
  events,
  slides
])

firebase.install(Vue);

export default new Vuex.Store({
  plugins: [fireStorePlugins],
  state: { test: true },
  actions: {},
  modules: {
    application,
    editor
  },
  mutations: {   
  }
});
